export enum RuleConflictTranslations {
  RuleTableHeader = 'modules.merchandising.rules.createAndEdit.searchConflictTable.headers.rule',
  StoresTableHeader = 'modules.merchandising.rules.createAndEdit.searchConflictTable.headers.stores',
  ScheduledTableHeader = 'modules.merchandising.rules.createAndEdit.searchConflictTable.headers.scheduled',
  RelatedRulesTableHeader = 'modules.merchandising.rules.createAndEdit.searchConflictTable.headers.relatedRules',
  StartTime = 'modules.merchandising.rules.createAndEdit.searchConflictTable.startTime',
  EndTime = 'modules.merchandising.rules.createAndEdit.searchConflictTable.endTime',
  RulesCount = 'modules.merchandising.rules.createAndEdit.searchConflictTable.rulesCount'
}
